import { gridSize } from '@atlaskit/theme/constants';

export const surveyInnerWidth = gridSize() * 55; // 440
export const surveyOffset = gridSize() * 6; // 48
